export default "__VITE_ASSET__7bfa1bf9__"